/**
 * @memberOf app.results
 * @ngdoc controller
 * @name ResultsController
 * @description Module used for the viewing of results for a particular study
 */
export default class ResultsController {

  constructor($window, ReportService, report, $sce) {
    /**
     * @memberOf ResultsController
     * @type {service}
     * @description Instance of angular's $window service
     */
    this.$window = $window;

    /**
     * @memberOf ResultsController
     * @type {ReportService}
     * @description Instance of ReportService
     */
    this.reportService = ReportService;

    /**
     * @memberOf ResultsController
     * @type {Object}
     * @description Report object that was clicked on in home.html
     */
    this.report = report;

    /**
     * @memberOf ResultsController
     * @type {Array}
     * @description Array of section objects
     */
    this.sections = [];

    /**
     * @memberOf ResultsController
     * @type {Array}
     * @description Array of summary tables
     */
    this.tables = [];

    /**
     * @memberOf ResultsController
     * @type {Array}
     * @description Array of introduction paragraphs
     */
    this.intro = '';

    /**
     * @memberOf ResultsController
     * @type {service}
     * @description Angular's $sce service for trusting HTML in report data
     */
    this.$sce = $sce;
  }

    SectionChanged(isOpen, sectionTitle) {
        this.reportService.postReportAction(isOpen, sectionTitle, this.report.userId).then(result => {

        });
    }


  /**
   * @memberOf ResultsController
   * @description Calls the Report service to generate PDF then opens the pdf
   */
  openReport() {
    // this.updateViewStatus('pdf');
    let ieEdge = false;
    let win = null;
    if (this.$window.navigator.msSaveOrOpenBlob) {
      ieEdge = true;
    } else {
      win = this.$window.open('', '_blank');
    }
    this.reportService.getPdf(this.report._id).then(result => {
      let blob = new Blob([result], { type: 'application/pdf' });
      blob.name = this.report.file_name;
      let fileUrl = (this.$window.URL || this.$window.webkitURL).createObjectURL(blob);
      if (ieEdge) {
        this.$window.navigator.msSaveOrOpenBlob(blob, `${this.report.file_name}.pdf`);
      } else {
        win.location = fileUrl;
      }
    });
  }

  /**
   * @memberOf ResultsController
   * @description Goes through all of the report data HTML and trusts it, so it can be shown on the screen. Calls
   * updateViewStatus if the report hasn't been viewed before
   */
  onInit() {
    this.report.report_data.accordions.forEach((section) => {
      this.sections.push({
        title: this.$sce.trustAsHtml(section.title),
        body: this.$sce.trustAsHtml(section.body),
        open: false
      });
    });

    this.report.report_data.tables.forEach((table) => {
      this.tables.push({
        data: this.$sce.trustAsHtml(table.data)
      });
    });

    if (this.report.report_data.introductions[0]) {
      this.intro = this.$sce.trustAsHtml(this.report.report_data.introductions[0].body);
    }

    // this.updateViewStatus('results');
  }

  /**
   * @memberOf ResultsController
   * @description Calls ReportService's update method to update that the report has been viewed.
   */
  // updateViewStatus(type) {
  //   let updatedReport = this.report;
  //   let viewedDate = new Date();

  //   switch (type) {
  //     case 'results':
  //       updatedReport.views.results_viewed.push(viewedDate);
  //       break;
  //     case 'pdf':
  //       updatedReport.views.pdf_downloaded.push(viewedDate);
  //       break;
  //   }
  //   this.reportService.update(this.report._id, updatedReport);
  // }
}

ResultsController.$inject = ['$window', 'ReportService', 'report', '$sce'];



// WEBPACK FOOTER //
// ./src/client/app/results/results.controller.js